module.exports = __webpack_public_path__ + "static/media/1_en.156b7436.png";